import ImagePreview from '../../components/admin/ui/ImagePreview';

export const getProjectColumns = (categories) => [
  {
    key: 'nom',
    label: 'Nom',
    render: (row) => (
      <div className="admin-row-media">
        <ImagePreview src={row.logo} size={28} />
        {row.nom?.fr || row.nom?.en}
      </div>
    ),
    sortable: true,
    sortValue: (row) => row.nom?.fr || row.nom?.en || ''
  },
  {
    key: 'category',
    label: 'Catégorie',
    render: (row) => categories.find((cat) => cat.id === row.category)?.label.fr || row.category,
    sortable: true,
    sortValue: (row) => categories.find((cat) => cat.id === row.category)?.label.fr || row.category || ''
  },
  { key: 'seturl', label: 'Slug', sortable: true }
];

export const projectCategoryColumns = [
  {
    key: 'label',
    label: 'Libellé',
    render: (row) => (
      <div className="admin-row-media">
        {row.label?.fr}
        {row.isDefault && <span className="admin-badge admin-badge-default">Par défaut</span>}
      </div>
    )
  }
];

export const projectCategoryFields = [{ name: 'label', label: 'Libellé', type: 'bilingual', required: true }];

export const getProjectFields = (technologies, categories) => [
  {
    name: 'category',
    label: 'Catégorie',
    type: 'select',
    options: categories.map((cat) => ({ value: cat.id, label: cat.label.fr }))
  },
  { name: 'seturl', label: 'Slug', type: 'text', required: true },
  { name: 'nom', label: 'Nom', type: 'bilingual', required: true },
  { name: 'contexte', label: 'Contexte', type: 'bilingual', as: 'textarea' },
  { name: 'resume', label: 'Résumé', type: 'bilingual', as: 'textarea' },
  { name: 'description', label: 'Description', type: 'bilingual', as: 'textarea' },
  {
    name: 'technologyIds',
    label: 'Technologies',
    type: 'select',
    multiple: true,
    options: technologies.map((tech) => ({ value: tech.id, label: tech.label.fr, icon: tech.icon }))
  },
  { name: 'logo', label: 'Logo', type: 'asset' },
  { name: 'images', label: 'Images', type: 'list', itemType: 'asset' },
  { name: 'url', label: 'URL', type: 'text' }
];

export const projectToFormValues = (project) => ({
  ...project,
  technologyIds: (project.technologies || []).map((t) => t.id)
});

export const projectToPayload = (values) => ({
  ...values,
  technologies: values.technologyIds || []
});
